import { SHOWROOM_SECTION_SOURCE } from '@makemydeal/dr-sales-checkin-types';
import { Actions } from '../actionTypes/actionTypes';

export const removeTradeInFromSection = () => ({
    type: Actions.REMOVE_TRADE_IN,
    payload: { targetIndex: undefined },
    meta: { source: SHOWROOM_SECTION_SOURCE }
});
